<div class="layout-sidebar-logo">
	<span>DOVE</span>
</div>
<app-menu></app-menu>
<div class="app-version">Version {{ appVersion }}</div>
